// src/superadmin/layout/Sidebar.jsx

import { useNavigate, useLocation } from "react-router-dom";
import Logo from "../../shared/components/Logo";

const NAV_SECTIONS = [
  {
    label: "",
    items: [
      {
        id: "Dashboard",
        icon: (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            className="lucide lucide-layout-dashboard w-4 h-4 shrink-0"
          >
            <rect width="7" height="9" x="3" y="3" rx="1"></rect>
            <rect width="7" height="5" x="14" y="3" rx="1"></rect>
            <rect width="7" height="9" x="14" y="12" rx="1"></rect>
            <rect width="7" height="5" x="3" y="16" rx="1"></rect>
          </svg>
        ),
      },
    ],
  },
  {
    items: [
      {
        id: "Organisations",
        icon: (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            className="lucide lucide-building2 w-4 h-4 shrink-0"
          >
            <path d="M6 22V4a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v18Z"></path>
            <path d="M6 12H4a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h2"></path>
            <path d="M18 9h2a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2h-2"></path>
          </svg>
        ),
      },
    ],
  },
  {
    items: [
      {
        id: "Manage Activity",
        icon: (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            className="lucide lucide-activity w-4 h-4 shrink-0"
          >
            <polyline points="22 12 18 12 15 21 9 3 6 12 2 12"></polyline>
          </svg>
        ),
      },
    ],
  }
];

const ROUTES = {
  Dashboard: "/superadmin/dashboard",
  Organisations: "/superadmin/organisations",
  "Module Assignment": "/superadmin/moduleassignment",
  "Manage Activity": "/superadmin/manageactivity",
};

function Sidebar({ onLogout }) {
  const location = useLocation();
  const navigate = useNavigate();

  const handleClick = (id) => {
    navigate(ROUTES[id]);
  };

  return (
    <aside className="sidebar">
      {/* Logo */}
      <div className="sidebar-logo">
        <Logo showMargin={false} />
      </div>

      {/* Navigation */}
      <nav className="sidebar-nav">
        {NAV_SECTIONS.map((section, index) => (
          <div className="nav-section" key={index}>
            {section.label && (
              <div className="nav-section-label">{section.label}</div>
            )}

            {section.items.map((item) => (
              <div
                key={item.id}
                className={`nav-item ${
                  location.pathname === ROUTES[item.id] ? "active" : ""
                }`}
                onClick={() => handleClick(item.id)}
              >
                <span className="nav-icon">{item.icon}</span>
                <span className="nav-text">{item.id}</span>
              </div>
            ))}
          </div>
        ))}
      </nav>

      {/* Logout */}
      <div className="nav-section" onClick={onLogout}>
        <div className="nav-item ">
          <span className="nav-icon">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              className="lucide lucide-log-out w-4 h-4 shrink-0"
            >
              <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" />
              <polyline points="16 17 21 12 16 7" />
              <line x1="21" y1="12" x2="9" y2="12" />
            </svg>
          </span>
          <span className="nav-text">Sign Out</span>
        </div>
      </div>
    </aside>
  );
}

export default Sidebar;
export { NAV_SECTIONS, ROUTES };
